import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationExtras } from '@angular/router';
import { SharedPreferencesService } from '../../../services/shared-preferences.service';

@Component({
  selector: 'full-layout',
  templateUrl: './full-layout.component.html'
})

export class FullLayoutComponent implements OnInit {

  selectedLocation: any;
  selectedCategory: any;
  categories: any[];
  locations: any[];
  activateMapToggle: boolean = true;
  mapChangedEventData:any = null;

  constructor(
    public sharedPreferencesService: SharedPreferencesService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.sharedPreferencesService.showHeader = true;
    
    this.locations = this.sharedPreferencesService.locations;
    this.categories = this.sharedPreferencesService.categories;
    
    this.selectedLocation = this.locations[0];
    this.selectedCategory = this.categories[0];
    
    this.router.events.subscribe((event) => {  
      if (event instanceof NavigationEnd) {
        this.route.firstChild.url.subscribe((url) => {
          if (url[0] && url[0].path === 'around-me') {
            this.initializeCategoryLocationDropdown();
          }
        })
      }
    });
  }

  changeCurrentMapToggleState(type) {
    this.activateMapToggle = !this.activateMapToggle;
    this.sharedPreferencesService.currentMapToogleState = type;
  }
  
  ngOnInit() {

    window.addEventListener('mapChanged', (event: CustomEvent) => {
      this.mapChangedEventData = event.detail;
    })
  }

  initializeCategoryLocationDropdown() {
    
    this.route.firstChild.params.subscribe((params) => {
      this.selectedLocation = this.sharedPreferencesService.getLocation('slug', params.city);
      this.selectedCategory = this.sharedPreferencesService.getCategory('slug', params.category);
    })
  }

  navigate(selectedLocation?) {
    let options = window.location
                      .search
                      .slice(1)
                      .split('&')
                      .reduce(function(a: any, b: any) {
                        b = b.split('=');
                        a[b[0]] = decodeURIComponent(b[1]);
                        return a;
                      }, {});

    if(selectedLocation) {
      options.lat = selectedLocation.lat;
      options.long = selectedLocation.long;
      // if(this.mapChangedEventData) {
      //   options.radius = this.mapChangedEventData.radius;
      // }
      options.radius = selectedLocation.radius;
      this.mapChangedEventData = null;
      options.autoAdjustMarkers = true;
    } else {
      delete options.autoAdjustMarkers;
    }
    
    let navigationExtras: NavigationExtras = {
      queryParams: this.mapChangedEventData? this.mapChangedEventData : options
    };
    console.log(navigationExtras);
    this.router.navigate(['around-me', this.selectedLocation.slug, this.selectedCategory.slug ], navigationExtras)
  }

  getUrl() {
    return encodeURIComponent(window.location.href);
  }

}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/components/layouts/full-layout/full-layout.component.ts